
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'CSSCheckIcon'
})
export default class CSSCheckIcon extends Vue {
  @Prop({ type: String, default: 'i' }) type!: string
  @Prop({ type: Number, required: true }) width!: number
  @Prop({ type: Number, required: true }) height!: number
  @Prop({ type: String, default: 'black' }) color!: string
  @Prop({ type: Number, default: 2 }) weight!: number

  get px() {
    return (number: number) => number.toString() + 'px'
  }
}
